import * as S from './logo.styles';
import howstore from "../../assets/howstore.png";

export const Logo = () => {
    return (
        <S.StoreLogo to="/">
            <img
                src={howstore}
                alt="Logo Howstore"
                width="50"
                height="50"
                fetchPriority="high"
                decoding="sync"
            />
        </S.StoreLogo>
    );
};
